"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setName = exports.networkRecieveStartLerpToXY = exports.networkRecieveSelectCrew = exports.removeDead = exports.updateAll = exports.killAll = exports.kill = exports.moveToXY = exports.create = exports.findByMultiIdSafe = exports.findByMultiId = exports.getAll = exports.mouseCursorUpdateTime = void 0;
var rogueMonofont_sidecar_1 = require("@dive/fonts/rogueMonofont-sidecar");
var spritesCursors_1 = require("@dive/spriteRecyclers/spritesCursors");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var echoFonts_sidecar_1 = require("@echo/echoFonts-sidecar");
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var imports_1 = require("@lib/imports");
var spring_sidecar_1 = require("@lib/spring-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var namespace = 'multiplayer-cursors';
exports.mouseCursorUpdateTime = 1 / 10;
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function findByMultiId(multiId) {
    return imports_1.l.find(getAll(), function (c) { return c.multiId == multiId; }) || null;
}
exports.findByMultiId = findByMultiId;
function findByMultiIdSafe(multiId) {
    var cur = findByMultiId(multiId);
    if (!cur) {
        cur = create(multiId);
    }
    return cur;
}
exports.findByMultiIdSafe = findByMultiIdSafe;
function create(multiId) {
    // let frame = sprites.voyTileCursor[0]
    // let imageCursor = spritesUtil.createImage(
    //   voyageLayers.getLayers().shipAbove,
    //   frame,
    // )
    // imageCursor.tint = voyageColors.red
    var color = voyageColors_sidecar_1.voyageColors.red;
    // let imageSelected = spritesUtil.createImage(
    //   voyageLayers.getLayers().shipAbove,
    //   frame,
    // )
    // imageSelected.tint = voyageColors.purple
    // TODO: use new text rendering
    var textCursor = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font4, 0, 0, voyageLayers_sidecar_1.voyageLayers.getLayers().shipAbove);
    stevieTexts2_sidecar_1.stevieTexts2.setScale(textCursor, 4);
    stevieTexts2_sidecar_1.stevieTexts2.setText(textCursor, '' + multiId);
    var textSelected = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font4, 0, 0, voyageLayers_sidecar_1.voyageLayers.getLayers().shipAbove);
    stevieTexts2_sidecar_1.stevieTexts2.setScale(textSelected, 4);
    stevieTexts2_sidecar_1.stevieTexts2.setText(textSelected, '' + multiId);
    var obj = {
        id: -1,
        idLoaded: -1,
        multiId: multiId,
        isDead: false,
        eType: 'voy-misc',
        // imageCursor: imageCursor,
        // imageSelected,
        crewSelected: null,
        textCursor: textCursor,
        textSelected: textSelected,
        springX: spring_sidecar_1.spring.create(),
        springY: spring_sidecar_1.spring.create(),
        springTileX: spring_sidecar_1.spring.create(),
        springTileY: spring_sidecar_1.spring.create(),
        name: 'Unknown',
        pickMode: 'normal',
        selectedSpell: null,
        x: 0,
        y: 0,
        updateTimer: 0,
        hideTimer: 0,
        isHidden: false,
        color: color,
    };
    objs.push(obj);
    spring_sidecar_1.spring.setDef(obj.springX, spring_sidecar_1.spring.defTight());
    spring_sidecar_1.spring.setDef(obj.springY, spring_sidecar_1.spring.defTight());
    spring_sidecar_1.spring.setDef(obj.springTileX, spring_sidecar_1.spring.defTight());
    spring_sidecar_1.spring.setDef(obj.springTileY, spring_sidecar_1.spring.defTight());
    return obj;
}
exports.create = create;
function moveToXY(obj, x, y) {
    obj.x = x;
    obj.y = y;
    stevieTexts2_sidecar_1.stevieTexts2.moveTo(obj.textCursor, x + 32, y);
}
exports.moveToXY = moveToXY;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function killAll() {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    removeDead();
}
exports.killAll = killAll;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
    removeDead();
}
exports.updateAll = updateAll;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        // c.imageCursor.destroy()
    });
}
exports.removeDead = removeDead;
function update(obj) {
    var dt = common_sidecar_1.common.getUpdateDelta();
    obj.updateTimer += dt;
    obj.hideTimer += dt;
    if (obj.hideTimer > 5) {
        obj.isHidden = true;
    }
    else {
        obj.isHidden = false;
    }
    // Is this us?
    if (obj.multiId === websockets_sidecar_1.websockets.getMultiId() || obj.multiId === 0) {
        obj.isHidden = true;
    }
    // obj.imageCursor.visible = !obj.isHidden
    stevieTexts2_sidecar_1.stevieTexts2.setVisible(obj.textCursor, !obj.isHidden);
    spring_sidecar_1.spring.update(obj.springX, dt);
    spring_sidecar_1.spring.update(obj.springY, dt);
    spring_sidecar_1.spring.update(obj.springTileX, dt);
    spring_sidecar_1.spring.update(obj.springTileY, dt);
    if (!obj.isHidden) {
        // TODO: write text into gamespace
        // rogueMonofont.writeAbsolute(
        //   obj.springX.position + 32,
        //   obj.springY.position,
        //   obj.name,
        // )
        if (obj.pickMode === 'normal') {
            var hoveredTile = spritesCursors_1.spritesCursors.getNext(obj.springTileX.position, obj.springTileY.position, sprites_sidecar_1.sprites.diveEffectsCursorMultiplayer[0]);
            hoveredTile.tint = obj.color;
            var cursor = spritesCursors_1.spritesCursors.getNext(obj.springX.position, obj.springY.position, sprites_sidecar_1.sprites.diveEffectsCursorMultiplayerPointer[0]);
            cursor.tint = obj.color;
        }
        if (obj.pickMode === 'cast') {
            if (obj.selectedSpell === null) {
                console.warn(namespace, 'no spell selected');
                // TODO: fix this
                // obj.selectedSpell = diveSpell_firewall
            }
            else {
                var tHereI = diveTilemap_sidecar_1.diveTilemap.convertXtoI(obj.springX.position);
                var tHereJ = diveTilemap_sidecar_1.diveTilemap.convertYtoJ(obj.springY.position);
                //let tHereI = obj.springTileX.position
                //let tHereJ = obj.springTileY.position
                var activate = false;
                var spell = obj.selectedSpell;
                var _a = diveTilemap_sidecar_1.diveTilemap.convertIJtoXY(tHereI, tHereJ), cursorTileX = _a.x, cursorTileY = _a.y;
                var cursorOptions = {
                    cursorI: tHereI,
                    cursorJ: tHereJ,
                    cursorTileX: cursorTileX,
                    cursorTileY: cursorTileY,
                    activate: activate,
                };
                var isValid = spell.spell_cursor(cursorOptions);
            }
        }
    }
    moveToXY(obj, obj.springX.position, obj.springY.position);
    if (obj.crewSelected) {
        if (!obj.isHidden) {
            var image = spritesCursors_1.spritesCursors.getNext(obj.crewSelected.x, obj.crewSelected.y, sprites_sidecar_1.sprites.diveEffectsCursorMultiplayerSelected[0]);
            image.tint = obj.color;
            stevieTexts2_sidecar_1.stevieTexts2.moveTo(obj.textSelected, obj.crewSelected.x + 32, obj.crewSelected.y);
            rogueMonofont_sidecar_1.rogueMonofont.writeAbsolute(obj.crewSelected.x + 32, obj.crewSelected.y, obj.name);
        }
        stevieTexts2_sidecar_1.stevieTexts2.setVisible(obj.textSelected, !obj.isHidden);
    }
    else {
        stevieTexts2_sidecar_1.stevieTexts2.setVisible(obj.textSelected, false);
    }
}
// TODO: new dive method
function networkRecieveSelectCrew(obj, cr) {
    obj.crewSelected = cr;
    obj.hideTimer = 0;
}
exports.networkRecieveSelectCrew = networkRecieveSelectCrew;
// TODO: new dive method
function networkRecieveStartLerpToXY(obj, x, y) {
    obj.springX.target = x;
    obj.springY.target = y;
    var tx = diveTilemap_sidecar_1.diveTilemap.convertXtoI(x);
    var ty = diveTilemap_sidecar_1.diveTilemap.convertYtoJ(y);
    var tileXY = diveTilemap_sidecar_1.diveTilemap.convertIJtoXY(tx, ty);
    obj.springTileX.target = tileXY.x;
    obj.springTileY.target = tileXY.y;
    obj.updateTimer = 0;
    obj.hideTimer = 0;
}
exports.networkRecieveStartLerpToXY = networkRecieveStartLerpToXY;
function setName(obj, name) {
    obj.name = name;
    stevieTexts2_sidecar_1.stevieTexts2.setText(obj.textCursor, name);
    stevieTexts2_sidecar_1.stevieTexts2.setText(obj.textSelected, name);
}
exports.setName = setName;
